import {
  INTERPRETER_CALL_TYPE_SELECTED,
  INTERPRETER_GENDER_SELECTED,
  INTERPRETER_INVITE_REQUEST_ID,
  INTERPRETER_INVITE_STATUS,
  INTERPRETER_LANGUAGE_SELECTED,
  INTERPRETER_LANGUAGE_UPDATED,
  INTERPRETER_INVITE_NOTIFICATION_ID,
  INTERPRETER_INVITE_RETRY_NOTIFCATION_ID,
  INTERPRETER_GENDER_OPTION_UPDATED,
  INTERPRETER_CALL_TYPE_UPDATED,
  INTERPRETER_ESTIMATED_TIME,
  INTERPRETER_ESTIMATED_TIME_AVAILABLE,
} from "./types/interpreter";

export const selectedInterpreterLanguage = (payload) => ({
  type: INTERPRETER_LANGUAGE_SELECTED,
  payload,
});

export const selectedInterpreterGender = (payload) => ({
  type: INTERPRETER_GENDER_SELECTED,
  payload,
});

export const selectedInterpreterVideoOption = (payload) => ({
  type: INTERPRETER_CALL_TYPE_SELECTED,
  payload,
});

export const interpreterLanguages = (payload) => ({
  type: INTERPRETER_LANGUAGE_UPDATED,
  payload,
});

export const interpreterInviteNotificationID = (payload) => ({
  type: INTERPRETER_INVITE_NOTIFICATION_ID,
  payload,
});

export const interpreterInviteRetryNotificationID = (payload) => ({
  type: INTERPRETER_INVITE_RETRY_NOTIFCATION_ID,
  payload,
});

export const setInterpreterRequestID = (payload) => ({
  type: INTERPRETER_INVITE_REQUEST_ID,
  payload,
});

export const setInterpreterRequestStatus = (payload) => ({
  type: INTERPRETER_INVITE_STATUS,
  payload,
});

export const interpreterGenderOption = (payload) => ({
  type: INTERPRETER_GENDER_OPTION_UPDATED,
  payload,
});

export const interpreterCallTypeOption = (payload) => ({
  type: INTERPRETER_CALL_TYPE_UPDATED,
  payload,
});

export const setInterpreterEstimateTime = (payload) => ({
  type: INTERPRETER_ESTIMATED_TIME,
  payload,
});

export const setEstimatedTimeAvailable = (payload) => ({
  type: INTERPRETER_ESTIMATED_TIME_AVAILABLE,
  payload,
});
